import { type AnalyticsProps } from '../../features';
import {
  ActivityOverview,
  IdeasByMilestoneStats,
  IdeasByPhaseStats,
  IdeasByStatusStats,
  IdeasByTagStats,
  IdeasByThemeStats,
  IdeaStats,
  UserLoginsStats,
  VotesAndCommentsStats
} from './';

export const Analytics = (props: AnalyticsProps) => {
  const { page, dataTableViewEnabled } = props;
  switch (page) {
    case 'activityoverview':
      return <ActivityOverview dataTableViewEnabled={dataTableViewEnabled} />;
    case 'ideastats':
      return <IdeaStats dataTableViewEnabled={dataTableViewEnabled} />;
    case 'ideasbyphase':
      return <IdeasByPhaseStats dataTableViewEnabled={dataTableViewEnabled} />;
    case 'ideasbymilestone':
      return <IdeasByMilestoneStats dataTableViewEnabled={dataTableViewEnabled} />;
    case 'themestats':
      return <IdeasByThemeStats dataTableViewEnabled={dataTableViewEnabled} />;
    case 'ideas_by_status':
      return <IdeasByStatusStats dataTableViewEnabled={dataTableViewEnabled} />;
    case 'ideas_by_tag':
      return <IdeasByTagStats dataTableViewEnabled={dataTableViewEnabled} />;
    case 'totvotecommentstats':
      return <VotesAndCommentsStats />;
    case 'loginstats':
      return <UserLoginsStats dataTableViewEnabled={dataTableViewEnabled} />;
    default:
      return <></>;
  }
};
